import script from "./Omnichannel.vue?vue&type=script&lang=ts&setup=true"
export * from "./Omnichannel.vue?vue&type=script&lang=ts&setup=true"

import "./Omnichannel.vue?vue&type=style&index=0&id=446e6690&lang=scss"

const __exports__ = script;

export default __exports__